import {GRAPHQL_SUBSCRIPTIONS_URL} from "./utils/constants";
import {SubscriptionClient} from 'subscriptions-transport-ws';

export const apolloSubscriptionTransportClient = new SubscriptionClient (
	GRAPHQL_SUBSCRIPTIONS_URL,
	{
		reconnect: true,
		lazy: true,
	}
);

